var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "video-dialog",
      attrs: {
        width: "900px",
        "append-to-body": "",
        title: _vm.currentVideo.title,
        visible: _vm.dialogVisibleVideo,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibleVideo = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("div", { staticClass: "video-style" }, [
        _vm.currentVideo.videoUrl
          ? _c(
              "video",
              {
                ref: "video",
                staticClass: "video-player",
                class: [_vm.screenWidth <= 1285 ? "video-width" : ""],
                attrs: {
                  controls: "",
                  controlslist: "nodownload noplaybackrate",
                  disablePictureInPicture: "",
                  height: "480",
                  width: "854",
                  autoplay: "",
                },
              },
              [
                _c("source", {
                  attrs: { src: _vm.currentVideo.videoUrl, type: "video/mp4" },
                }),
              ]
            )
          : _c("div", [_vm._v(_vm._s(_vm.$i18.language("暂无数据")))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }